import { render } from "./EditModel2dTable.vue?vue&type=template&id=5885000e&scoped=true"
const script = {}

import "./EditModel2dTable.vue?vue&type=style&index=0&id=5885000e&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5885000e"]])

export default __exports__